import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import HotelNetRevenueKpiCard from 'lumen/components/hotel/net-revenue/kpi-card';
import type { KpiData } from 'lumen/utils/net-revenue/types';

interface HotelNetRevenueKpiSectionSignature {
  Args: {
    isLoading?: boolean;
    kpiData: KpiData | undefined;
  };
}

const HotelNetRevenueKpiSection = <template>
  <div class="grid grid-cols-4 gap-400" data-test-id="net-revenue-kpi-section">
    <HotelNetRevenueKpiCard
      @dataTestId="kpi-card-net-revenue"
      @isLoading={{@isLoading}}
      @kpi={{@kpiData.netRevenue}}
      @title={{t "net_revenue.kpi_net_revenue"}}
    />
    <HotelNetRevenueKpiCard
      @dataTestId="kpi-card-cost"
      @isLoading={{@isLoading}}
      @kpi={{@kpiData.cost}}
      @title={{t "net_revenue.cost"}}
    />
    <HotelNetRevenueKpiCard
      @dataTestId="kpi-card-net-adr"
      @isLoading={{@isLoading}}
      @kpi={{@kpiData.netAdr}}
      @title={{t "net_revenue.net_adr"}}
    />
    <HotelNetRevenueKpiCard
      @dataTestId="kpi-card-avg-cost"
      @isLoading={{@isLoading}}
      @kpi={{@kpiData.avgCost}}
      @title={{t "net_revenue.kpi_avg_cost"}}
    />
  </div>
</template> satisfies TOC<HotelNetRevenueKpiSectionSignature>;

export default HotelNetRevenueKpiSection;
